var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffb822",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32,
    d: "M320 120l48 48-48 48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352 168H144a80.24 80.24 0 00-80 80v16M192 392l-48-48 48-48",
    fill: "none",
    stroke: "#ffb822",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160 344h208a80.24 80.24 0 0080-80v-16",
    fill: "none",
    stroke: "#ffb822",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.c84b17819a8b4a10ac8025a4a222885f.svg";
export { ForwardRef as ReactComponent };